import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateWithLocale } from '../../shared/utils';

const PrintFooter = ({ isSharing }) => {
  const { t } = useTranslation();
  const currentDate = new Date().toISOString();

  return (
    <footer className="print-footer mt-5 pt-4">
      <div className="footer-divider">
        <hr className="my-4" />
      </div>
      <div className="d-flex justify-content-between align-items-center text-muted small">
        <div>
          <p className="mb-0">
            {isSharing 
              ? t('planDetail.print.sharedFrom')
              : `${t('planDetail.print.generatedWith')} ${formatDateWithLocale(currentDate, 'PPP')}`}
          </p>
        </div>
        <div>
          <p className="mb-0">{t('planDetail.print.happyTravels')}</p>
        </div>
      </div>
    </footer>
  );
};

// Default props
PrintFooter.defaultProps = {
  isSharing: false
};

export default PrintFooter; 